var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machine-slideshow"},_vm._l((_vm.machines),function(machine,index){return _c('Card',{key:index,attrs:{"index":index,"machine":machine}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }